type MediaLocale = typeof import('../en/media').default

const media = {
	unsplash: {
		attribution: 'Foto de {{author}}',
		discovery: {
			title: 'Busca en Unsplash para elegir una imagen',
			description:
				'Lanza una búsqueda para explorar resultados y seleccionar la imagen que quieres usar.',
		},
		idLookup: {
			label: 'Buscar por ID de foto',
			placeholder: 'p. ej., abc123XYZ',
			action: 'Buscar',
			help: 'Úsalo cuando ya conoces el ID exacto de la foto en Unsplash.',
			error: 'No se pudo encontrar esa foto por ID.',
		},
		search: {
			placeholder: 'p. ej., tecnología, naturaleza, negocios...',
		},
		loading: 'Cargando imágenes...',
		error: 'No se pudieron cargar las imágenes. Intenta de nuevo.',
		empty: 'No se encontraron imágenes para esta búsqueda.',
		photoAlt: 'Foto de Unsplash',
		courseCoverAlt: 'Imagen de apoyo para la ruta {{courseTitle}}',
	},
} satisfies MediaLocale

export default media
